import React, { useEffect, useState } from "react";
import { Breadcrumb, Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO";

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + MyApi.BLOGLIST, {
          headers: { Authorization: MyApi.SECRET_KEY },
        });

        if (res.data.status) {
          setBlogs(res.data.data);
        }
      } catch (err) {
        console.error("Blog API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  // ✅ SEO Setup
  useSEO({
    title: "Blog | Taxi Service Varanasi",
    description:
      "Read latest travel tips, taxi booking guides, Varanasi travel blogs, and helpful articles for your journey.",
    keywords:
      "Varanasi blog, taxi tips, travel blog Varanasi, cab booking guide, travel articles",
    canonical: window.location.href,
  });

  return (
    <div>
      {/* Breadcrumb */}
      <div className="BreadcrumbStyle">
        <Container>
          <h1>Blog</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Blog</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      <Container className="py-5">
        <Row>
          {/* Loading */}
          {loading && <p>Loading blogs...</p>}

          {/* No Data */}
          {!loading && blogs.length === 0 && <p>No blog posts available.</p>}

          {/* Blog List */}
          {!loading &&
            blogs.length > 0 &&
            blogs.map((item, index) => (
              <Col md={3} className="mb-4" key={index}>
                <Card className="h-100 shadow-sm">
                  {/* Blog Image */} <Link
                      to={`/blog/${item.categoryurl}`} 
                    >
                  <Card.Img
                    variant="top"
                    src={item.image_url}
                    alt={item.categoryname}
                  /></Link> 
                  <Card.Body>
                    <Card.Title>{item.categoryname}</Card.Title>
                    <Card.Title>
                      {new Date(item.created_on).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </Card.Title>
                    <Link
                      to={`/blog/${item.categoryurl}`}
                      className="btn btn-primary btn-sm"
                    >
                      Read More
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </Container>
    </div>
  );
}
